import { render, staticRenderFns } from "./ClassroomMeetingTab.vue?vue&type=template&id=6fc64e49&"
import script from "./ClassroomMeetingTab.vue?vue&type=script&lang=js&"
export * from "./ClassroomMeetingTab.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomMeetingTab.vue?vue&type=style&index=0&id=6fc64e49&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports